// extracted by mini-css-extract-plugin
export default {"quantity_action":"QuantityAction_quantity_action__+NdvG","quantity_action_small":"QuantityAction_quantity_action_small__4lTIC"};